import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IProduct } from './../../shared/models/products/product';
import { PurchaseStateService } from './../../shared/services/purchase-state.service';
import { UserService } from './../../../shared/services/user.service';

@Component({
  selector: 'app-products-renewal',
  templateUrl: './products-renewal.component.html'
})
export class ProductsRenewalComponent implements OnInit {
  products: IProduct[];
  isUserInactive: boolean = false;
  isPre2020: boolean=false;
  constructor(private purchaseState: PurchaseStateService,
    private userService: UserService, private router: Router)
    { }

  ngOnInit() {
    this.products = this.purchaseState.currentState.products;    
    this.isUserInactive = this.userService.isCurrentUserInactive;   
    if (new Date() <= new Date("01/01/2020"))
    {
      this.isPre2020 = true;
    }
  }

  onCancel() {
    this.router.navigate(['']);
  }

  onContinue() {
    this.router.navigate(['purchase/products']);
  }

  onCheckout() {
    this.router.navigate(['purchase/checkout/productsrenewal']);
  }
}
